import { render } from "./basic-unit-price-filter.vue?vue&type=template&id=b2f564e8&scoped=true&lang=pug"
import script from "./basic-unit-price-filter.vue?vue&type=script&lang=js"
export * from "./basic-unit-price-filter.vue?vue&type=script&lang=js"

import "./basic-unit-price-filter.vue?vue&type=style&index=0&id=b2f564e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f564e8"]])

export default __exports__